/*
 * @param file - The file to upload
 * @param presignedUrl - The presigned URL to upload the file to
 *
 * @returns The response from the upload
 */
export const uploadFileToS3 = async (file: File, presignedUrl: string) => {
  const AWS_HEADERS = {
    accessControlExposeHeaders: 'Content-Disposition',
    contentType: file.type,
    responseContentDisposition: 'attachment',
    filename: file.name,
    attachment: file.name,
    size: `${file.size}`
  };

  return await fetch(presignedUrl, {
    headers: AWS_HEADERS,
    method: 'put',
    body: file
  });
};
